import { type Context, createContext } from 'react';

import type { AgentVersioningConfig } from '../../types';

export const agentVersioningConfigContext: Context<AgentVersioningConfig | undefined> =
	createContext<AgentVersioningConfig | undefined>(undefined);
